import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Check karo App.js isi folder mein hai

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);